import { FC } from 'react';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { Button, LottieIcon, Placeholder } from '$uikit';
import { useTranslator } from '$hooks';
import { goTo } from '$navigation/helper';
import { MINE } from '$shared/constants/pages';
import { useDispatch } from 'react-redux';
import { mainActions } from '$store/main';

export const MineExploreNoFunds: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();

  const handleMine = () => {
    dispatch(mainActions.setPopup(null));
    goTo(MINE);
  };

  return (
    <BottomSheet>
      <Placeholder
        icon={<LottieIcon name="duck_money" loop size={120} />}
        title={t('mine_explore_no_funds_title')}
        actions={<Button onClick={handleMine}>{t('mine_explore_no_funds_btn')}</Button>}
        iconSize={120}
        compact
      >
        {t('mine_explore_no_funds_text')}
      </Placeholder>
    </BottomSheet>
  );
};
